import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * The backend exposes both a new route (`/blog-posts`) and a legacy route
 * (`/blog/posts`). Production and preview may temporarily run different
 * revisions, so we always try the new route first and fall back to the
 * legacy one on a 404. Any other error is re-thrown.
 */
async function fetchWithFallback(newPath, legacyPath) {
  try {
    const { data } = await axios.get(`${API}${newPath}`);
    return data;
  } catch (err) {
    if (err?.response?.status === 404) {
      const { data } = await axios.get(`${API}${legacyPath}`);
      return data;
    }
    throw err;
  }
}

export async function listBlogPosts() {
  const data = await fetchWithFallback("/blog-posts", "/blog/posts");
  const posts = Array.isArray(data) ? data : data?.posts || [];
  return [...posts].sort(
    (a, b) => new Date(postDate(b) || 0) - new Date(postDate(a) || 0),
  );
}

export async function getBlogPost(slug) {
  return fetchWithFallback(`/blog-posts/${slug}`, `/blog/posts/${slug}`);
}

// Post fields land in either camelCase (publishedAt) or snake_case
// (published_at) depending on the source. Small helpers to normalise.
export const postDate = (p) => p?.publishedAt || p?.published_at || p?.date;
export const postCoverImage = (p) =>
  p?.featuredImage || p?.featured_image || p?.coverImage;
export const postReadTime = (p) => p?.readTime || p?.read_time || "5 min read";

export function formatPostDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}
